import { MonthPickerInput } from "shared/ui/components/MonthPickerInput";

const MonthPickerInputField = ({
  field,
  helpers,
  autoSubmit,
  onSubmit,
  onChange,
  onChanged,
  ...restProps
}: any) => {
  const handleChange = (value) => {
    helpers.setValue(value);

    if (onChanged) {
      onChanged(field.name, value);
    }

    if (autoSubmit && onSubmit) {
      onSubmit();
    }
  };

  return (
    <MonthPickerInput
      {...restProps}
      value={field.value}
      onChange={handleChange}
    />
  );
};

export default MonthPickerInputField;
